import type { LegacyProfile } from '../model/schema';

/** Balance-card input derived from the legacy profile — no placeholder. */
export interface LegacyBalanceView {
  amount: number;
  currency: string;
}

/**
 * The profile balance card's figure, read from `balance.current` on the OLD
 * backend's `GET /vendors/me`.
 *
 * Returns `undefined` while the profile is unknown so the card renders its
 * skeleton; once loaded the REAL amount is returned as-is — including `0`.
 * A missing or zero balance must never fall back to the dashboard's
 * `-9_300_000` design placeholder.
 */
export function legacyBalanceView(
  profile: Pick<LegacyProfile, 'balance'> | undefined,
): LegacyBalanceView | undefined {
  if (!profile) return undefined;
  return { amount: profile.balance.current, currency: 'UZS' };
}
